import { Box, Skeleton } from "@mui/joy";
import PackageCard from "./PackageCard";
import { useMarketContext } from "../../contexts/MarketContext";

const ElementList = () => {
    const {
        packages,
        selected,
        orgData,
        addons,
        currentAddons,
        currentExtraAddons,
        isLoadedFetching,
        currentPlan,
    } = useMarketContext();

    const getPackageState = (pkg) => {
        const disableFree =
            selected?.state?.id >= 2 || orgData?.state.licence >= 2;
        const isSelected =
            selected?.state?.stripe_price_id === pkg.stripe_price_id;
        const isAddon = addons.state.find(
            (a) => a.stripe_price_id === pkg.stripe_price_id
        );
        const isActivePlan = currentPlan?.state?.id === pkg.id;

        return { disableFree, isSelected, isAddon, isActivePlan };
    };

    return (
        <>
            <Box display="flex" flexWrap="wrap" gap={2} mb={4}>
                {!isLoadedFetching()
                    ? Array.from({ length: 4 }).map((_, idx) => (
                          <Skeleton
                              key={idx}
                              variant="rectangular"
                              width={200}
                              height={240}
                          />
                      ))
                    : packages.state.map((pkg, index) => {
                          const {
                              disableFree,
                              isActive,
                              isAddon,
                              isSelected,
                              isActivePlan,
                          } = getPackageState(pkg);

                          return (
                              <PackageCard
                                  key={index}
                                  pkg={pkg}
                                  currentAddons={currentAddons}
                                  currentExtraAddons={currentExtraAddons}
                                  isActive={isActive}
                                  isActivePlan={isActivePlan}
                                  isAddon={isAddon}
                                  isSelected={isSelected}
                                  disableFree={disableFree}
                                  selected={selected}
                              />
                          );
                      })}
            </Box>
        </>
    );
};

export default ElementList;
